import { Breadcrumb } from 'components/breadcrumb'
import { PecSwitch, PrivateRoute } from 'components/route'
import { useRouteMatch } from 'react-router'
import Permissions from 'types/Permissions.generated'
import { EstagioCreateView } from 'view/estagiario/components/EstagioCreateView'
import { EstagioUpdateView } from 'view/estagiario/components/EstagioUpdateView'
import { ProfissionalListView } from 'view/profissional/list/ProfissionalListView'

import { ConfiguracaoAgendaLotacaoView } from './agenda/ConfiguracaoAgendaLotacaoView'
import { FechamentoAgendaLotacaoView } from './agenda/fechamento/FechamentoAgendaLotacaoView'
import { ConfiguracaoAgendaOnlineLotacaoView } from './agenda-online/ConfiguracaoAgendaOnlineLotacaoView'
import { AcessoCreateView } from './detail/acesso/AcessoCreateView'
import { AcessoEditView } from './detail/acesso/AcessoEditView'
import { LotacaoAlterarView } from './detail/lotacao/LotacaoAlterarView'
import { LotacaoCreateView } from './detail/lotacao/LotacaoCreateView'
import { ProfissionalDetailView } from './detail/ProfissionalDetailView'
import { ProfissionalCreateView } from './ProfissionalCreateView'
import { ProfissionalEditView } from './ProfissionalEditView'

export function ProfissionalRootView() {
  const match = useRouteMatch()

  return (
    <>
      <Breadcrumb title='Profissionais' />

      <PecSwitch>
        <PrivateRoute
          exact
          path={`${match.url}`}
          component={ProfissionalListView}
          permission={Permissions.visualizarProfissionais}
        />
        <PrivateRoute
          exact
          path={`${match.url}/create/`}
          component={ProfissionalCreateView}
          permission={Permissions.visualizarProfissionais.cadastrarEditarEExcluir}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/edit`}
          component={ProfissionalEditView}
          permission={Permissions.visualizarProfissionais.cadastrarEditarEExcluir}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/lotacoes/create`}
          component={LotacaoCreateView}
          permission={Permissions.visualizarProfissionais.visualizarAcessos.cadastrarEditarEExcluirLotacao}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/lotacoes/:lotacaoId(\\d+)/edit`}
          component={LotacaoAlterarView}
          permission={Permissions.visualizarProfissionais.visualizarAcessos.cadastrarEditarEExcluirLotacao}
        />
        {/*TODO: (RNG) Alterar o componente de ProvateRoute para bloquear o acesso das rotas via URL quando a flag está desabilitada */}
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/lotacoesEstagio/create`}
          component={EstagioCreateView}
          permission={Permissions.visualizarProfissionais.visualizarAcessos.cadastrarEditarEExcluirLotacao}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/lotacoesEstagio/:estagioId(\\d+)/edit`}
          component={EstagioUpdateView}
          permission={Permissions.visualizarProfissionais.visualizarAcessos.cadastrarEditarEExcluirLotacao}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/acessos/create`}
          component={AcessoCreateView}
          permission={Permissions.visualizarProfissionais.visualizarAcessos.cadastrarEditarEExcluirAcesso}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/acessos/:acessoId(\\d+)/edit`}
          component={AcessoEditView}
          permission={Permissions.visualizarProfissionais.visualizarAcessos.cadastrarEditarEExcluirAcesso}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/dados/configuracaoAgenda/:lotacaoId(\\d+)`}
          component={ConfiguracaoAgendaLotacaoView}
          permission={Permissions.visualizarProfissionais.visualizarAcessos.configurarAgenda}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/dados/configuracaoAgendaOnline/:lotacaoId(\\d+)`}
          component={ConfiguracaoAgendaOnlineLotacaoView}
          permission={Permissions.visualizarProfissionais.visualizarAcessos.configurarAgendaOnline}
        />
        <PrivateRoute
          exact
          path={`${match.url}/:profissionalId(\\d+)/dados/acessos/fechamento/:lotacaoId(\\d+)`}
          component={FechamentoAgendaLotacaoView}
          permission={Permissions.visualizarProfissionais.visualizarAcessos.fecharAgenda}
        />
        <PrivateRoute
          path={`${match.url}/:profissionalId(\\d+)`}
          component={ProfissionalDetailView}
          permission={Permissions.visualizarProfissionais}
        />
      </PecSwitch>
    </>
  )
}
